import { getToken, setToken, removeToken
    , getReviewToken, setReviewToken
    , getWechatOpenId, setWechatOpenId
    , getTuiWechatOpenId, setTuiWechatOpenId, setViewSource, getViewSource
}
from '@/utilities/userToken'
import api from '@/api'

export default {
    state: ()=> ({
        userInfo: {},
        userToken: getToken(),
        userReviewToken: getReviewToken(),
        wechatOpenId: getWechatOpenId(),
        tuiWechatOpenId: getTuiWechatOpenId(),
        isShowLikePopups:true,
        viewSource: getViewSource()
    }),
    actions: {
        GET_USER_INFO: async ({ commit }, userToken) => {
            if (userToken && userToken.length > 0) {
                const { success, data, errMsg } = await api.user.getUserInfo()
                if (!success) console.error(errMsg)
                commit('SET_USER_INFO', { userInfo: data })
            }
        },
        SET_USER_TOKEN: ({ commit }, token) => {
            commit('SET_USER_TOKEN', { token })
        },
        SET_VIEW_SOURCE: ({ commit }, viewSource) => {
            commit('SET_VIEW_SOURCE', { viewSource })
        }
    },
    mutations: {
      SET_USER_TOKEN: (state, { token }) => {
          state.userToken = token
          setToken(token)
      },
      REMOVE_USER_TOKEN (state) {
          state.userToken = ''
          state.userInfo = {}
          removeToken()
      },
      SET_USER_INFO: (state, { userInfo }) => {
          if (userInfo) {
            state.userInfo = userInfo;
          } else {
              state.userInfo = {}
          }
      },
      SET_REWARD_TOKEN (state, rewardToken) {
          state.userReviewToken = rewardToken
          setReviewToken(rewardToken)
      },
      SET_WECHAT_OPENID (state, openId) {
          state.wechatOpenId = openId
          setWechatOpenId(openId)
      },
      SET_TUI_WECHAT_OPENID (state, openId) {
          state.tuiWechatOpenId = openId
          setTuiWechatOpenId(openId)
      },
      SET_LIKE_ROUTE_POPUPS(state,value){
          state.isShowLikePopups = value
      },
      SET_VIEW_SOURCE: (state, { viewSource }) => {
        state.viewSource = viewSource;
        setViewSource(viewSource)
      }
    }
  }
